import {createStore} from "vuex"
import api from "../api/api";

export const MUTATION_SET_COMPANY_STATISTIC = 'setCompanyStatistic';
export const MUTATION_SET_MY_SHARE = 'setMyShare';
export const MUTATION_SET_YEAR_SHARE = 'setYearShare';
export const MUTATION_SET_TOKEN = 'setToken';
export const MUTATION_SET_USERNAME = 'setUsername';

const store = createStore({
  state() {
    const token = localStorage.getItem('token')

    return {
      username: '',
      company: {
        statistic: []
      },
      share: {
        my: [],
        years: [],
      },
      token: token,
    }
  },

  getters: {
    isAuth: state => {
      return !!state.token
    },
  },

  mutations: {
    [MUTATION_SET_COMPANY_STATISTIC](state, data) {
      state.company.statistic = data
    },
    [MUTATION_SET_MY_SHARE](state, data) {
      state.share.my = data
    },
    [MUTATION_SET_YEAR_SHARE](state, data) {
      state.share.years = data
    },
    [MUTATION_SET_TOKEN](state, token) {
      localStorage.setItem('token', token)
      state.token = token
    },
    [MUTATION_SET_USERNAME](state, username) {
      state.username = username
    }
  },

  actions: {
    async fetchCompanyStatistic({commit}, data) {
      let result = await api.company.statistic()
      commit(MUTATION_SET_COMPANY_STATISTIC, result.data.data)
    },
    async fetchShareSummary({commit, state}, data) {
      let result = await api.share.summary()
      commit(MUTATION_SET_MY_SHARE, result.data.my)
      commit(MUTATION_SET_YEAR_SHARE, result.data.years)
      commit(MUTATION_SET_USERNAME, result.data.username)
    },
    async login({commit}, {username, password}) {
      const result = await api.auth.login(username, password)
      if (result.status !== 200) {
        return false
      }

      commit(MUTATION_SET_TOKEN, result.data.access_token)
      return true
    },
    logout({commit}) {
      commit(MUTATION_SET_TOKEN, '')
    },
    setToken({commit}, {token}) {
      commit(MUTATION_SET_TOKEN, token)
    }
  }
})

export default store
